import ApiPermisos from "../../services/apiPermisos";

export default {
  namespaced: true,
  state: {
    errorMsj: "",
    categories: [],
    loadingH: false,
    reemplazo: [
      {
        name: "Laura Castellanos cc 11402012",
        cargo: "Mesera",
        pdvOrigen: "BBC - Pub Colina",
        pdvDestino: "BBC - Pub Colina",
      },
    ],
    reemplazar: [
      {
        id: 1,
        name: "Luis Fernando Díaz Ortíz cc 11402012",
        position: {
          name: "Mesero",
        },
        pdv: "BBC - Pub Colina",
      },
    ],
    loadingAutocomplete: false,
    listAutocompleteReemplazar: [],
    listAutocompleteReemplazo: [],
  },
  getters: {
    getReemplazo: (state) => {
      return state.reemplazo;
    },

    getReemplazar: (state) => {
      return state.reemplazar;
    },
  },
  mutations: {
    setReemplazo: (state, obj) => {
      state.reemplazo = [];
      state.reemplazo = obj;
    },

    setReemplazar: (state, obj) => {
      state.reemplazar = [];
      state.reemplazar = obj;
    },

    setAutocompleteReemplazo: (state, reemplazo) => {
      state.listAutocompleteReemplazo = reemplazo;
    },

    setAutocompleteReemplazar: (state, reemplazar) => {
      state.listAutocompleteReemplazar = reemplazar;
    },

    setLoadingAutocomplete: (state, loadingAutocomplete) => {
      state.loadingAutocomplete = loadingAutocomplete;
    },
  },
  actions: {
    // Get autocomplete reemplazar
    actGetReemplazar: async ({ commit }, data) => {
      commit("setLoadingAutocomplete", true);
      let response = await ApiPermisos.getAutocompleteNovedades(data);
      if (response.error) {
        commit("setLoadingAutocomplete", false);
        return response.error;
      } else {
        commit("setLoadingAutocomplete", false);
        commit(
          "setAutocompleteReemplazar",
          response != null ? response.data.data : null
        );
      }
      return true;
    },

    // Agregar un item reemplazo
    actPushTableReemplazar: async ({ commit }, data) => {
      commit("setLoading", true);
      commit("setLoading", false);
      commit("setReemplazar", data);
      return true;
    },
  },
};
